module.exports = "/_next/static/images/game-3-fingerprint-part-2-wrong-78e0b6afcbce35ed084f6db64ea7480a.png";